export default {
  steps: {
    setup_fee: 'Einrichtungsgebühr',
    business_info: 'Unternehmensdaten',
    create_preview: 'Vorschauvertrag erstellen',
    preview: 'Vertragsvorschau',
    sign: 'Vertrag unterschreiben',
  },
  buttons: {
    next: 'Vertrag vorschauen',
    save_and_continue: 'Speichern & fortfahren',
    update: 'Vorschau aktualisieren',
    cancel: 'Aktuellen abbrechen',
    skip: 'Vertragserstellung überspringen',
  },
  create_preview: {
    header: 'Vorschauvertrag erstellen',
    description: 'Geben Sie die Empfängerdaten für den Vertrag ein. Sie können sie vor dem Senden noch ändern.',
  },
  sign: {
    update_notice: 'Um den Vertrag zu ändern, brechen Sie den aktuellen ab und bearbeiten Sie die Details.',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
  },
};
